module.exports = __webpack_public_path__ + "assets/images/ending1_822c7abce18aee4d96108b7374b84800.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ending/ending1.png
// module id = 133
// module chunks = 0